





























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { dictServe, doublePrevention } from '@/api/installServer';
import { TableStripe } from '@/mixins/tableStripe';

@Component({
  components: { },
  mixins: [TableStripe],
})
export default class ApprovalDetail extends Vue {
  @Prop(Object) row: any;

  private isDetail: any = true;
  private activeName: any = 'new';
  private loadingFalse: any = false;
  private loadingSuccess: any = false;

  private formData: any = {};
  private resFormData: any = {};
  private riskPointList: any = [];
  private dangerSourceIdList: any = [];


  private controlMeasuresDataList: any = [];

  created() {
    if (this.row.rowType === 'insert' || this.row.rowType === 'update') {
      this.activeName = 'new';
    }
    if (this.row.rowType === 'delete') {
      this.activeName = 'old';
    }
    this.getRiskDangerList();
    this.getDetail(); // 详情
  }

  approvalPass(type: any) {
    this.$confirm('是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        if (type === 'fail') {
          this.loadingFalse = true;
          doublePrevention.approvalRiskControlInventoryNoPass([this.row.id]).then((res: any) => {
            this.loadingFalse = false;
            if (res.code == 200) {
              this.$message.success('审核完成！');
              this.backClose();
            } else {
              this.$message.warning(res.msg)
            }
          })
        } else {
          this.loadingSuccess = true;
          doublePrevention.approvalRiskControlInventoryHandle([this.row.id]).then((res: any) => {
            this.loadingSuccess = false;
            if (res.code == 200) {
              this.$message.success('审核完成！');
              this.backClose();
            } else {
              this.$message.warning(res.msg)
            }
          })
        }

      })
      .catch(() => {
        this.$message.info('已取消');
      });
  }


  // 详情
  private getDetail() {
    doublePrevention.infoApprovalRiskControlInventoryData(this.row.id).then((res: any) => {
      this.resFormData = res.data;
      this.resFormData.oldData = JSON.parse(res.data.oldData);
      this.resFormData.newData = JSON.parse(res.data.newData);
      this.formData = this.resFormData.newData;
      this.controlMeasuresDataList[0] = this.resFormData.newData.technologyMeasureHazardList;
      this.controlMeasuresDataList[1] = this.resFormData.newData.individualProtectShowHazardList;
      this.controlMeasuresDataList[2] = this.resFormData.newData.controlMeasuresHazardList;
    })
  }
  handleClick(tab: any, event: any) {
    if (this.activeName === 'new') {
      this.formData = this.resFormData.newData;
      this.controlMeasuresDataList[0] = this.resFormData.newData.technologyMeasureHazardList;
      this.controlMeasuresDataList[1] = this.resFormData.newData.individualProtectShowHazardList;
      this.controlMeasuresDataList[2] = this.resFormData.newData.controlMeasuresHazardList;
    } else {
      this.formData = this.resFormData.oldData;
      this.controlMeasuresDataList[0] = this.resFormData.oldData.technologyMeasureHazardList;
      this.controlMeasuresDataList[1] = this.resFormData.oldData.individualProtectShowHazardList;
      this.controlMeasuresDataList[2] = this.resFormData.oldData.controlMeasuresHazardList;
    }
    console.log(this.formData,'this.formData');
  }
  private getRiskDangerList() {
    doublePrevention.getRiskAll({}).then((res: any) => {
      if (res.code === '200') {
        this.riskPointList = res.data.filter((item: any) => item.type === '风险点');
        this.dangerSourceIdList = res.data.filter((item: any) => item.type === '危险源');
      } else {
        this.$message.warning(res.msg);
      }
    }).catch(() => {
      this.$message.error('获取数据失败！');
    });
  }

  private backClose() {
    this.$emit('backCloseList');
  }
}
